import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import NearMe from '../pages/near-me/page';
import LocationPage from '../pages/near-me/city/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/services', element: <Services /> },
  { path: '/near-me', element: <NearMe /> },
  { path: '/near-me/:city', element: <LocationPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
